module.exports = "pegasus/assets/blocks/column-1-theme2.png";